/** @jsx jsx */ //please do not remove this implementation because the css will not be loaded without it
import React from "react";
import { jsx } from '@emotion/react'
import CompanyAddress from "../CompanyAddress";
import {table, textWeight, detailsTable, tableFooter, coloredThead, smallPadding} from '../../styles/tableStyles'



const ReceiptTemplate = ({ customerDetails, itemDetails, footer ,isCompnay=true }) => {
    return (
        <table border='0' width='100%'>
            <tbody>
                <tr>
                    <td>
                        <CompanyAddress iscompany = {isCompnay}/>

                        {/* Customer Details Table */}
                        <table css={[table, detailsTable, smallPadding]}>
                            {customerDetails}  {/* customerDetails has <tbody> */}
                        </table>

                        {/* Items Table */}
                        <table css={[table, detailsTable]}>
                            {itemDetails.props.children} {/* unwrap children so no extra <tbody> */}
                        </table>

                        {/* Footer Table */}
                        <table css={[table, tableFooter]}>
                            {footer} 
                            <p>       </p>

                             {/* footer has <tbody> */}
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>
    )
};

function ItemsTable({children,headData=[],coloredTableHead= coloredThead}) {
    return(
        <table css={[table,detailsTable]}>
            <thead>
            <tr>
                {headData.map((item, index)=>(
                    <th css={[coloredThead,textWeight]} key={index}><span><strong>{item.value}</strong></span></th>
                ))}
            </tr>
            </thead>
            {children}
        </table>
    )
}

export {ReceiptTemplate,ItemsTable}
